import { Field, Formik } from "formik";
import { Button, Input, PopupModal } from "shared";
import "./FiltersModal.scss";
import { useGetControls, useUpdateBot } from "hooks/controls";

interface FiltersModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const { mutateAsync: updateBot } = useUpdateBot();
  const { data } = useGetControls();

  const initialValues = {
    distanceFrom: data?.distanceFrom || 0,
    distanceTo: data?.distanceTo || 0,
    maxDailyOrders: data?.maxDailyOrders || 0,
  };

  return (
    <PopupModal isOpen={isOpen} onClose={onClose}>
      <h2 className="popup-modal__header popup-modal__header--mb-20">
        Ustawienia filtrów
      </h2>
      <div className="popup-modal__content filters-modal">
        <Formik
          initialValues={initialValues}
          onSubmit={(values) =>
            updateBot(values, {
              onSuccess: () => {
                onSuccess && onSuccess();
                onClose();
              },
            })
          }
          enableReinitialize
        >
          {({ errors, values, handleSubmit, touched }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="transport">Transport - Filtr stały</label>
                  <p className="dummy-input">Plandeka</p>
                </div>
                <div className="form-group">
                  <label htmlFor="maxDailyOrders">
                    Maksymalna ilość zleceń <span>(dziennie)</span>
                  </label>
                  <div className="form-group__inputs">
                    <Field
                      type="number"
                      id="maxDailyOrders"
                      name="maxDailyOrders"
                      as={Input}
                      maxLength={3}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="distanceFrom">Odległość</label>
                  <div className="form-group__inputs">
                    <Field
                      type="number"
                      id="distanceFrom"
                      name="distanceFrom"
                      as={Input}
                      maxLength={5}
                      label="Od"
                      rightLabel={<span className="right">km</span>}
                    />
                    <Field
                      type="number"
                      id="distanceTo"
                      name="distanceTo"
                      as={Input}
                      maxLength={5}
                      label="Do"
                      rightLabel={<span className="right">km</span>}
                    />
                  </div>
                </div>
                <div className="popup-modal__buttons">
                  <Button
                    label="Anuluj"
                    onClick={onClose}
                    size="large"
                    styleType="stroke"
                    className="button--wide"
                  />
                  <Button
                    label="Zapisz filtry"
                    onClick={() => handleSubmit()}
                    styleType="primary"
                    size="large"
                    className="button--wide"
                  />
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </PopupModal>
  );
};

export default FiltersModal;
